export default "__VITE_ASSET__DENNsAp8__"